import React from 'react';
import './ResendLinkComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {FormInput} from '@homeaway/react-form-components';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import PropTypes from 'prop-types';
import ErrorViewComponent from '../ErrorViewComponent/ErrorViewComponent';
import {TrackingContext} from '@homeaway/react-event-tracking';
import aamClient from '../../util/aamClient';

const validate = require('validate.js');

class ResendLinkComponent extends React.Component {
    static get propTypes() {
        return {
            lingua: PropTypes.shape({read: PropTypes.func, exists: PropTypes.func}),
            isWaiting: PropTypes.bool,
            enableLoading: PropTypes.func,
            disableLoading: PropTypes.func,
            updatePage: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            emailAddress: '',
            emailError: '',
            error: ''
        };
    }

    emailAddressChanged = (event) => {
        this.setState({[event.target.name]: event.target.value});
    };

    submitForm = (e) => {
        e.preventDefault();
        this.props.enableLoading();
        this.setState({emailError: null});
        setTimeout(() => {
            this.processSubmitForm();
        }, 800);
    };

    processSubmitForm = () => {
        if (this.isValidEmailAddress()) {
            this.context.trigger('generic.click', {eventcategory: 'lex.auth', eventaction: 'email.submit'});
            aamClient.resendConfirmationEmail({'emailAddress': this.state.emailAddress}).then((response) => {
                if (response.status === 200) {
                    this.props.updatePage('success');
                } else {
                    this.setState({error: this.props.lingua.read('error.generic')});
                }
            });
        } else {
            this.setState({emailError: this.props.lingua.read('lex.email.invalid')});
        }
        this.props.disableLoading();
    };

    isValidEmailAddress = () => {
        let emailAddress = this.state.emailAddress.trim();
        let emailValid = !validate({from: emailAddress}, {from: {email: true}});
        return emailValid;
    };

    render() {
        const emailAddress = this.state.emailAddress;
        const error = this.state.error;
        const emailError = this.state.emailError;
        const waiting = this.props.isWaiting;
        return (
            <div className="ResendLinkComponent">
                <ErrorViewComponent error={error}/>
                <p className="Tittle">{this.props.lingua.read('lex.ticket.resend.msg')}</p>
                <form onSubmit={this.submitForm} noValidate>
                    <FormInput
                        id="email-address"
                        name="emailAddress"
                        label={this.props.lingua.read('form.placeholder.emailAddress')}
                        className="ResendLinkInput"
                        value={emailAddress}
                        errorMsg={emailError}
                        onChange={this.emailAddressChanged}
                    />
                    <div className="ActionButton">
                        <ButtonPrimary label={this.props.lingua.read('lex.ticket.send')} type="submit" disabled={!emailAddress}>
                            <LoadingOverlay loading={waiting}/>
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        );
    }
}

ResendLinkComponent.contextType = TrackingContext;
export default ResendLinkComponent;
